import { BonusPointsSheetState, BonusPointsSheetTileState } from './BonusPointsSheetState.js';
import { Tracking } from '../shared/Tracking.js';
import { DataContainer } from '@otto-ec/tracking-bct';

export class BonusPointsSheetTracking {
    constructor(private readonly _tracking: Tracking) {}

    trackOpenedSheet(sheetState: BonusPointsSheetState) {
        this._tracking.submitEvent({
            name: 'open',
            features: [
                {
                    id: 'up_points',
                    name: 'UpPoints',
                    status: 'clicked',
                    labels: {
                        up_PointsRedeem: ['open'],
                        up_RedeemedPoints: [sheetState.redeemedPointsBeforeSubmit],
                        up_RedeemedBalance: [sheetState.redeemedBalanceBeforeSubmit],
                        up_CountPossibleTiles: [this._computePossibleTiles(sheetState)],
                        ...this._searchMessageBoxLabel(sheetState)
                    }
                },
                ...this._createTileFeatures(sheetState.tiles)
            ]
        });
    }

    trackSubmittedSheet(sheetState: BonusPointsSheetState) {
        const maybeSelectedTile = sheetState.tiles.find(tile => tile.status === 'selected');

        this._tracking.submitEventMerge({
            name: 'submit',
            features: [
                {
                    id: 'up_points',
                    name: 'UpPoints',
                    status: 'success',
                    labels: {
                        up_PointsRedeem: ['redeem'],
                        up_RedeemedPoints: [maybeSelectedTile?.points ?? '0'],
                        up_RedeemedBalance: [maybeSelectedTile?.balance ?? '0.00'],
                        up_CountPossibleTiles: [this._computePossibleTiles(sheetState)],
                        ...this._searchMessageBoxLabel(sheetState)
                    }
                },
                ...this._createTileFeatures(sheetState.tiles)
            ]
        });
    }

    trackClosedSheet(sheetState: BonusPointsSheetState) {
        this._tracking.submitEvent({
            name: 'close',
            features: [
                {
                    id: 'up_points',
                    name: 'UpPoints',
                    status: 'clicked',
                    labels: {
                        up_PointsRedeem: ['closed'],
                        up_RedeemedPoints: [sheetState.redeemedPointsBeforeSubmit],
                        up_RedeemedBalance: [sheetState.redeemedBalanceBeforeSubmit],
                        up_CountPossibleTiles: [this._computePossibleTiles(sheetState)],
                        ...this._searchMessageBoxLabel(sheetState)
                    }
                },
                ...this._createTileFeatures(sheetState.tiles)
            ]
        });
    }

    private _computePossibleTiles(sheetState: BonusPointsSheetState) {
        return sheetState.tiles.filter(tile => tile.status !== 'disabled').length.toString();
    }

    private _searchMessageBoxLabel(sheetState: BonusPointsSheetState): DataContainer {
        return !!sheetState.messageBoxReason ? { up_MessageBox: [sheetState.messageBoxReason] } : {};
    }

    private _createTileFeatures(tiles: BonusPointsSheetTileState[]) {
        return tiles.map((tile, index) => {
            const position = index + 1;

            return {
                id: 'up_points_tile' + position,
                name: 'UpPointsTile',
                parentId: 'up_points',
                status: tile.status,
                labels: {
                    up_TilePosition: [position.toString()],
                    up_TilePoints: [tile.points],
                    up_TileValue: [tile.balance]
                }
            };
        });
    }

    trackError(sheetState: BonusPointsSheetState, errorMessageId: string) {
        this._tracking.submitEvent({
            name: 'submit',
            features: [
                {
                    id: 'up_points',
                    name: 'UpPoints',
                    status: 'error',
                    labels: {
                        up_PointsRedeem: ['error'],
                        ...this._searchMessageBoxLabel(sheetState)
                    }
                },
                {
                    id: 'order_message',
                    name: 'OrderMessage',
                    status: 'visible',
                    labels: {
                        order_ErrorMessage: [errorMessageId]
                    }
                }
            ]
        });
    }
}
